<ng-container *ngIf="player$ | async as player">
  <span class="d-block text-truncate" [innerHTML]="player.country"></span>
</ng-container>
